import { NgModule } from '@angular/core';
import { ProductCardNavigationDirective } from './product-card-navigation.directive';

@NgModule({
  declarations: [ProductCardNavigationDirective],
  exports: [ProductCardNavigationDirective],
})
export class ProductCardNavigationModule {}
